import { useRouter } from 'next/navigation'

/**
 * Used to temporarily highlight a new item in the UI with query params and then remove it after a delay
 * Ex: highlight a project that was just created for five seconds
 */
export function useTemporaryHighlight() {
  const router = useRouter()

  const addTempHighlight = (
    paramName: string,
    paramValue: string,
    pathname: string,
    delay = 5000
  ) => {
    // Add the highlight parameter
    const newQueryString = new URLSearchParams(window.location.search)
    newQueryString.set(paramName, paramValue)
    // Append the new folder id to the existing path params
    router.push(`${pathname}?${newQueryString.toString()}`)

    // Clear the new param from URL after delay to reset the highlight effect
    setTimeout(() => {
      const currentParams = new URLSearchParams(
        window.location.search.toString()
      )
      currentParams.delete(paramName)
      router.replace(
        `${window.location.pathname}?${currentParams.toString()}`,
        { scroll: false }
      )
    }, delay)
  }

  return addTempHighlight
}
